const mapObject = (o, cb) => {
  const copy = {};
  Object.keys(o).forEach((key) => {
    copy[key] = cb(o[key], key);
  });
  return copy;
};
export {
  mapObject as m
};
//# sourceMappingURL=map-object-d5031296.mjs.map
